import React, { useState, useEffect } from 'react';
import { 
  PlusIcon, 
  PencilIcon,
  TrashIcon
} from '@heroicons/react/24/outline';
import { treatmentApi, TreatmentRecord, TreatmentSummary } from '../../api/treatments';

interface TreatmentManagementProps {
  onAddTreatment: () => void;
  onRefresh: () => void;
}

const TreatmentManagement: React.FC<TreatmentManagementProps> = ({
  onAddTreatment,
  onRefresh,
}) => {
  const [treatments, setTreatments] = useState<TreatmentRecord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTreatmentData();
  }, []);

  const loadTreatmentData = async () => {
    try {
      setLoading(true);
      const treatmentsData = await treatmentApi.getAll();
      setTreatments(treatmentsData);
    } catch (error) {
      console.error('Error loading treatment data:', error);
      setTreatments([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEditTreatment = (treatment: TreatmentRecord) => {
  };

  const handleDeleteTreatment = async (treatment: TreatmentRecord) => {
    if (window.confirm('Are you sure you want to delete this treatment?')) {
      try {
        await treatmentApi.delete(treatment.id);
        await loadTreatmentData();
        onRefresh();
      } catch {
      }
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium text-slate-900">Treatment Management</h3>
        <button
          onClick={onAddTreatment}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700"
        >
          <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
          Add Treatment
        </button>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <div className="px-4 py-5 sm:p-6">
          <p className="text-sm text-slate-500">
            {treatments.length} treatments found
          </p>
        </div>
      </div>
    </div>
  );
};

export default TreatmentManagement;
